import React, {PropTypes} from 'react';
import { FormattedMessage } from 'react-intl';
import { showDocField } from 'app/businessRules';

import Modal from 'routes/app/components/Modal';
import Button from 'routes/app/components/Button';
import Input from 'routes/app/components/Input';
import Select from 'routes/app/components/Select';
import Row from 'routes/app/components/Row';
import Col from 'routes/app/components/Col';
import Attachments from './Attachments';

import './style.scss';

const DocsDetailModal = ({translate, attachments, children, docTypes, onClickAgree, onClickDisagree, fields:{
    type, number, regPlace, regDate, id}}) => {

    const AgreeEl = (<div>
        <Button onClick={onClickAgree} waves="light" modal="close" flat>{translate({id:'unit.button.saveAndClose'})}</Button>
        <Button onClick={onClickAgree} waves="light" flat>{translate({id:'unit.goods.modal.submit'})}</Button>
    </div>);

    return (
        <Modal
            className="docs-modal"
            trigger={children}
            onClickAgree={onClickAgree}
            onClickDisagree={onClickDisagree}
            header={translate({id:'unit.docs.modal.header'})}
            textDisagree={onClickAgree ? translate({id:'unit.docs.modal.close'}) : translate({id:'unit.docs.modal.edit'})}
            agreeElement={onClickAgree && AgreeEl}
            closeOnAgree={false}
        >
            <Row>
                <Select s={12} m={6} label={translate({id:'doc.type'})}
                        options={docTypes} optionValue="code" optionLabel="desc"
                    {...type} />

                {showDocField({type}, 'number') &&
                <Input s={12} m={6} label={translate({id:'doc.number'})} {...number}
                       error={number.error && translate({id:number.error.transId}, number.error.values)}/>
                }

            </Row>
            <Row>
                {showDocField({type}, 'regPlace') &&
                <Input s={12} m={6} label={translate({id:'doc.regPlace'})} {...regPlace}
                       error={regPlace.error && translate({id:regPlace.error.transId}, regPlace.error.values)}/>
                }

                {showDocField({type}, 'regDate') &&
                <Input s={12} m={6} label={translate({id:'doc.regDate'})} placeholder={translate({id:'input.help.date'})} {...regDate}
                       error={regDate.error && translate({id:regDate.error.transId}, regDate.error.values)} />
                }

            </Row>

            {id.value ?
            <Attachments
                attachments={attachments}
                documentId={id.value}
                buttonText={translate({id: 'doc.attachment.select'})}
                uploadText={translate({id: 'doc.attachment.btn.upload'})}
                cancelText={translate({id: 'doc.attachment.btn.cancel'})}
                errorMessage={translate({id:'doc.attachment.upload.failed'})}/>
                :
                <Row className="visit__units__notification"><Col s={12}>{translate({id:'doc.attachment.saveFirst'})}</Col></Row>
            }

            <Input type="hidden" {...id} />
        </Modal>
    );
};

DocsDetailModal.propTypes = {
    children: PropTypes.node,
    docTypes: PropTypes.array,
    attachments: PropTypes.array,
    onClickAgree: PropTypes.func,
    onClickDisagree: PropTypes.func,
    fields: PropTypes.object,
    translate: PropTypes.func
};

export default DocsDetailModal;
